import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "drawer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-chouti_shouqi" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "slot-content" }
const _hoisted_5 = {
  key: 0,
  class: "drawer-footer"
}

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  size: {
    type: String,
    default: '50%'
  },
  title: {
    type: String,
    default: ''
  },
  cancelText: {
    type: String,
    default: t('取消')
  },
  okText: {
    type: String,
    default: t('确定')
  },
  visible: {
    type: Boolean,
    default: false
  },
  showBtn: {
    type: Boolean,
    default: true
  },
  className: {
    type: String,
    default: ''
  }
},
  emits: ['beforeClose', 'update:visible', 'ok'],
  setup(__props, { emit }) {

const props = __props



const width = computed(() => {
  let w = '50%'
  if (props.size.indexOf('px') > -1) {
    w = window.innerWidth < (Number(props.size.replace('px', '')) + 20) ? window.innerWidth - 20 + 'px' : props.size
  }
  return w
})
const visible2 = computed({
  get: () => props.visible,
  set: (val) => {
    emit('update:visible', val)
  }
})
const close = () => {
  emit('beforeClose')
}
const ok = () => {
  emit('ok')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_drawer, {
      modelValue: _unref(visible2),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible2) ? (visible2).value = $event : null)),
      title: __props.title,
      size: _unref(width),
      "before-close": close,
      "destroy-on-close": "",
      "show-close": false,
      "append-to-body": true,
      "modal-class": 'drawer-component ' + __props.className
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "drawer-back",
          onClick: close
        }, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        (__props.showBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_button, {
                class: "btn",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.cancelText), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "btn",
                onClick: ok
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.okText), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["modelValue", "title", "size", "modal-class"])
  ]))
}
}

})